// Internal modules
import { appStore } from '@/store';
import { apolloClient } from '@/lib/apollo';
import { CREATE_BANK_ACCOUNT_CANDIDATE_MUTATION } from './graphql';

/**
 * @function createBankAccountCandidate
 * @param {object} payload
 * @returns {Promise}
 * @description Creates a bank account candidate
 */
const createBankAccountCandidate = variables => {
  const { api: apiActions, ui: uiActions } = appStore.getActions();
  return apolloClient
    .mutate({
      mutation: CREATE_BANK_ACCOUNT_CANDIDATE_MUTATION,
      variables,
    })
    .then(({ data }) => {
      const { addBankCandidate } = data;
      apiActions.setBankCandidateData(addBankCandidate);
      uiActions.toggleIsFormSubmitting(false);
      uiActions.toggleIsSepaInterstitialOpen(true);
    })
    .catch(error => {
      uiActions.toggleIsFormSubmitting(false);
    });
};

export { createBankAccountCandidate };
